import ClientReportComponents from "../components/Layout/ClientReport/ClientReportComponents";

export default function ClientReport() {
  return <ClientReportComponents />;
}
